<template>
	<div v-if="assetForm" class="py-8">
		<Card>
			<template #content>
				<AssetPropertiesForm :form="assetForm" 
					@on-save="saveAsset" 
					@on-delete="confirmDelete" 
					@on-recover="confirmRecover" 
					:is-deleted="assetForm.is_deleted" 
					:disabled="!$auth.hasPermission('update:assets')"/>
			</template>
		</Card>
	</div>
</template>

<script>
import AssetPropertiesForm from "@/Forms/Asset/AssetPropertiesForm.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";

export default {
	name: "AssetPropertiesView",
	components: {AssetPropertiesForm},
	data() {
		return {
			assetForm: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
		'on-recover',
	],
	computed: {
		...mapStores(useAssetsStore)
	},
	methods: {
		async saveAsset() {
			try {
				const response = await this.assetForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.asset_saved'),
          life: 3000
        });
				this.$emit('on-save');
				this.$router.replace({ params: {...this.$route.params, asset: response.data.id} });
			} catch (error) {
				//
			}
		},
		confirmDelete(){
			this.$confirm.require({
				group: 'delete',
				message: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.are_you_sure_you_want_to_delete_this_asset'),
				header: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.delete_asset'),
				accept: () => {
					this.deleteAsset();
				},
				reject: () => {
					this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.asset_was_not_deleted'),
            life: 3000
          });
				}
			});
		},
		async deleteAsset() {
			try {
				if (this.$route.params.asset !== 'NEW') {
					await this.assetsStore.deleteAsset(this.$route.params.asset);
					this.$emit('on-delete');
				}
				this.$router.push({name: 'admin.assets', params: {...this.$route.params, asset: undefined}});
			} catch (error) {
				console.log(error);
			}
		},
		confirmRecover() {
			this.$confirm.require({
				group: 'confirm',
				message: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.are_you_sure_you_want_to_recover_this_asset'),
				header: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.recover_asset'),
				accept: () => {
					this.recoverAsset();
				},
				reject: () => {
					this.$toast.add({
						severity: 'info',
						summary: this.$t('common.cancelled'),
						detail: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.asset_was_not_recovered'),
						life: 3000
					});
				}
			});
		},
		async recoverAsset() {
			try {
				const assetId = this.assetForm?.id || this.$route.params.asset;

				await this.assetsStore.recoverAsset(assetId);
				// Reload the asset form to reflect the restored state
				this.assetForm = await this.assetsStore.editAsset(assetId);
				this.$emit('on-save');
				
			} catch (error) {
				console.log(error);
			}
		},

	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if(newValue){
          console.log(newValue)
					if(this.$route.params.asset === 'NEW'){
						this.assetForm = await this.assetsStore.createAsset();
					} else {
						this.assetForm = await this.assetsStore.editAsset(this.$route.params.asset);
					}
				} else {
					this.assetForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
